'use client';
import { useEffect, useRef, useState, type ReactNode } from 'react';

// ?layout= topic answer (Founder 01/10/26): the stored answer_text stays whole in the DOM, clamped to 1–2 lines; "עוד" opens it.
export default function TopicAnswer({ children, lines, fontSize = 15, weight = 400, color = '#334155', link = '#1d4ed8', bg = '#f8fafc', lineHeight = 1.5 }: { children: ReactNode; lines: 1 | 2; fontSize?: number; weight?: number; color?: string; link?: string; bg?: string; lineHeight?: number }) {
  const ref = useRef<HTMLParagraphElement>(null);
  const [open, setOpen] = useState(false);
  const [over, setOver] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el || open) return;
    const m = () => setOver(el.scrollHeight > el.clientHeight + 1);
    m();
    const ro = new ResizeObserver(m); ro.observe(el);
    return () => ro.disconnect();
  }, [open]);
  return (
    <div className="relative mt-1">
      <p ref={ref} style={{ fontSize, fontWeight: weight, lineHeight, color, margin: 0, ...(open ? {} : { display: '-webkit-box', WebkitLineClamp: lines, WebkitBoxOrient: 'vertical' as const, overflow: 'hidden' }) }}>
        {children}
        {open && <> <button type="button" onClick={() => setOpen(false)} className="font-bold" style={{ color: link }}>פחות</button></>}
      </p>
      {over && !open && (
        <button type="button" onClick={() => setOpen(true)} aria-label="הצגת התשובה המלאה" className="absolute font-bold"
          style={{ left: 0, bottom: 0, fontSize, lineHeight, color: link, paddingInlineStart: 22, background: bg.startsWith('#') && bg.length === 7 ? `linear-gradient(to left, ${bg}00, ${bg} 18px)` : bg }}>
          עוד
        </button>
      )}
    </div>
  );
}
